import amplitude from "amplitude-js";

export const initAmplitude = () => {
  amplitude.getInstance().init(process.env.REACT_APP_AMPLITUDE);
};

export const setPageVisit = (page) => {
  amplitude.getInstance().logEvent("page visit", page);
};

export const sendAmplitudeData = (eventType, eventProperties) => {
  amplitude.getInstance().logEvent(eventType, eventProperties);
};

export const setShare = (platform) => {
  amplitude.getInstance().logEvent("Shared", platform);
};

export const setCategoryClick = (category) => {
  amplitude.getInstance().logEvent("Category changed", category);
};

export const setSocial = (social) => {
  amplitude.getInstance().logEvent("Social platform changed", social);
};
